<template>
  <section id="inputs">
    <!-- <form class="p-5">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group"><label for="" class="required">Text</label><input type="text" class="form-control" required></div>
          <div class="form-group"><label for="">Email</label><input type="email" class="form-control"></div>
          <div class="form-group"><label for="">Number</label><input type="number" class="form-control"></div>
          <div class="form-group"><label for="">Password</label><input type="password" class="form-control"></div>
          <div class="form-group"><label for="">Phone</label><input type="tel" class="form-control"></div>
          <div class="form-group"><label for="">URL</label><input type="url" class="form-control"></div>
        </div>  
        <div class="col-md-4">
          <div class="form-group"><label for="">Date</label><input type="date" class="form-control"></div>
          <div class="form-group"><label for="">Date time local</label><input type="datetime-local" class="form-control"></div>
          <div class="form-group"><label for="">Time</label><input type="time" class="form-control"></div>
          <div class="form-group"><label for="">Week</label><input type="week" class="form-control"></div>
          <div class="form-group"><label for="">Month</label><input type="month" class="form-control"></div>
          <div class="form-group">
            <label for="exampleFormControlSelect1">Select</label>
            <select class="form-control" id="exampleFormControlSelect1">
              <option value="en">Option</option>
              <option value="en-us">English</option>
              <option value="es">Español (Spanish)</option>
              <option value="de">Deutsch (German)</option>
              <option value="tr">Türkçe (Turkish)</option>
              <option value="zh-s">简体中文 (Chinese, Simplified)</option>
              <option value="ja">日本語 (Japanese)</option>
              <option value="nl">Nederlands (Dutch)</option>
            </select>
          </div>
        </div>  
        <div class="col-md-4">  
          <div class="form-group"><label for="">Color</label><input type="color" class="form-control" style="width:48px"></div>
          <div class="form-group">
            <label for="">Range</label>
            <input type="range" name="weight" id="range_weight" class="custom-range" value="5" min="1" max="100" oninput="range_weight_disp.value = range_weight.value">
            <output  id="range_weight_disp"></output>         
          </div>
          <div class="form-group">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile">
              <label class="custom-file-label" for="customFile">Choose file</label>
            </div>
          </div>
          <div class="form-group">
            <label for="exampleFormControlTextarea1" class="required">Textarea</label>
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
          </div>
          <div class="form-group">
            <div class="checkbox checkbox-default d-inline-block mr-3">
              <input id="checkbox1" type="checkbox">
              <label for="checkbox1">
                Checkbox 1
              </label>
            </div>
            <div class="checkbox checkbox-default d-inline-block">
              <input id="checkbox1" type="checkbox">
              <label for="checkbox1">
                Checkbox 2
              </label>
            </div>
          </div>  
          <div class="form-group">  
            <div class="radio radio-primary radio-inline">
              <input type="radio" id="inlineRadio1" value="option1" name="radioInline">
              <label for="inlineRadio1">
                Inline One
              </label>
            </div>
            <div class="radio radio-primary radio-inline">
              <input type="radio" id="inlineRadio2" value="option2" name="radioInline">
              <label for="inlineRadio2">
                Inline Two
              </label>
            </div>
          </div>  
          <div class="form-group">  
            <div class="toggle toggle-primary d-inline-block mr-3">
              <label>
                <input type="checkbox">
                <span>Default</span>
              </label>
            </div>
            <div class="toggle toggle-primary d-inline-block">
              <label>
                <input type="checkbox">
                <span>checked</span>
              </label>
            </div>
          </div>  
        </div>
      </div>    
      <button class="btn btn-primary" type="submit">Submit</button>
    </form> -->

    
    <div class="demo">
      <h5>Form control model</h5>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="postcode" class="required">Postcode</label>
            <input 
                class="form-control" 
                id="postcode" 
                type="text" 
                placeholder="e.g. 3000"
                aria-invalid="true" 
                aria-describedby="hint-info error-msg" required />
            <small id="hint-info">Postcode is 4 digits</small>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="postcode" class="required">Postcode</label>
            <input 
                class="form-control is-invalid" 
                id="postcode" 
                type="text" 
                value="AUS123456"
                aria-invalid="true" 
                aria-describedby="hint-info error-msg" required />
            <small id="hint-info">Postcode is 4 digits</small>
            <small id="error-msg" class="invalid-feedback">
                <i aria-hidden="true" class="gel-icon-error"></i> 
                Please provide a valid postcode
            </small>
          </div>
        </div>
      </div>
      <form>
        <h5>Form controls</h5>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="exampleFormControlInput">Input field</label>
              <input type="text" class="form-control" id="exampleFormControlInput" placeholder="start typing ...">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput1">Email address</label>
              <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput2">Password</label>
              <input type="password" class="form-control" id="exampleFormControlInput2" name="password">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput4">Pick a date</label>
              <input type="date" class="form-control" id="exampleFormControlInput4" name="date">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput7">Pick a time</label>
              <input type="time" name="time" class="form-control" id="exampleFormControlInput7">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput5">Number (between 1 and 5)</label>
              <input type="number" name="quantity" min="1" max="5" class="form-control" id="exampleFormControlInput5">
            </div>
            <div class="form-group">
              <label for="exampleFormControlInput6">Phone</label>
              <input type="tel" name="phone" class="form-control" id="exampleFormControlInput6">
            </div>
            <div class="form-group">
              <label for="exampleFormControlSelect1">Example select</label>
              <select class="form-control" id="exampleFormControlSelect1">
                <option value="en">English</option>
                <option value="en-us">English (US)</option>
                <option value="es">Español (Spanish)</option>
                <option value="de">Deutsch (German)</option>
                <option value="tr">Türkçe (Turkish)</option>
                <option value="zh-s">简体中文 (Chinese, Simplified)</option>
                <option value="ja">日本語 (Japanese)</option>
                <option value="nl">Nederlands (Dutch)</option>
              </select>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="readonly1">Readonly</label>
              <input class="form-control mb-3" type="text" value="username-123456" readonly="readonly" id="readonly1">
            </div>
            <div class="form-group">
              <label for="dsiabled1">Disabled</label>
              <input id="dsiabled1" class="form-control mb-3" type="text" disabled="disabled"/>
            </div>
            <div class="form-group">
              <label for="root_positionDetails_salary">Prefix</label>
              <div class="input-group">
                <div class="input-group-prepend"><span aria-hidden="true" class="input-group-text">$</span></div>
                <input class="form-control" id="root_positionDetails_salary" label="Salary" required="" type="text" step="any" maxlength="19" value="">
              </div>
            </div>
            <div class="form-group">
              <label for="readonly1">Suffix</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2">@example.com</span>
                </div>
              </div>
            </div>
            <div class="form-group">  
              <label for="readonly1">Addon action</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="button-addon2">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" id="button-addon2">Send</button>
                </div>
              </div>
            </div>
            <div class="form-group"><label for="customRange1">Example range</label><input type="range" id="customRange1" class="form-control-range"></div>
            <div class="form-group">
              <label for="customFile">File upload</label>
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="customFile">
                <label class="custom-file-label" for="customFile">Choose file</label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="exampleFormControlTextarea1">Example textarea</label>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
        </div>
        <h5>Sizes</h5>
        <div class="row">
          <div class="col-sm-4"><input class="form-control form-control-lg" type="text" placeholder=".form-control-lg"></div>
          <div class="col-sm-4"><input class="form-control" type="text" placeholder="Default input"></div>
          <div class="col-sm-4"><input class="form-control form-control-sm" type="text" placeholder=".form-control-sm"></div>
        </div>
      </form>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/forms/inputs.md";
export default {
  name: "inputs",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.forms.inputs.name);
    this.$emit("update-tagline", this.$root.yamlData.forms.inputs.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
